import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Spinner from "../shared/Spinner";
import TripServices from "../services/externalServices/tripServices";
import { Link } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {
  Divider,
  Avatar,
  Grid,
  CardContent,
  Stack,
  SvgIcon,
  Button,Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Snackbar 
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PhoneAndroidTwoToneIcon from "@mui/icons-material/PhoneAndroidTwoTone";
import BadgeTwoToneIcon from "@mui/icons-material/BadgeTwoTone";
import RouteView from "../map/RouteView";
import { GridAddIcon } from "@mui/x-data-grid";
// import './TripDetails.css'
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import StarIcon from '@mui/icons-material/Star';
// import PaymentIcon from '@mui/icons-material/Payment';

function TripDetails() {
  const [tripDetails, setTripDetails] = useState();
  const [open, setOpen] = useState(false); // State to control the dialog visibility
  const [selectedTripId, setSelectedTripId] = useState(null); // Track the trip ID to delete
  const [snackBarOpen, setSnackBarOpen] = useState(false); // State for Snackbar visibility
  const [snackBarMessage, setSnackBarMessage] = useState(""); // Message for Snackbar
  const [snackBarSeverity, setSnackBarSeverity] = useState("success"); // Severity type for Snackbar (success, error)
  const { id } = useParams();

  useEffect(() => {
    const getTripDetails = async () => {
      try {
        const tripData = await TripServices.getTrip(id);
        console.log("tripDetails", tripData);
        setTripDetails(tripData);
      } catch (error) {
        console.error("Error fetching trip details:", error);
      }
    };
    getTripDetails();
  }, []);

  const formattedDate = (date) => {
    const options = {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    };
    const formattedDate = new Date(date);
    return formattedDate.toLocaleTimeString("en-GB", options);
  };

  const formattedTime = (date) => {
    const options = {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    const formattedTime = new Date(date);
    return formattedTime.toLocaleTimeString("en-GB", options);
  };

  const handleOpenDialog = (tripId) => {
    setSelectedTripId(tripId);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedTripId(null);
  };

  const handleDeleteTrip = async () => {
    try {
      const response = await TripServices.deleteTripData(selectedTripId);
      if (response.message === "Trip and associated records deleted successfully") {
        setSnackBarMessage("Trip deleted successfully!");
        setSnackBarSeverity("success");
      } 
      else if(response.error==="Unauthorized: Super Admin access required"){
        setSnackBarMessage("Only Super Admin can delete the trip");
        setSnackBarSeverity("error");
      }
      else {
        setSnackBarMessage("Failed to delete trip. Please try again.");
        setSnackBarSeverity("error");
      }
    } catch (error) {
      console.error("Error deleting trip:", error);
      setSnackBarMessage("An error occurred. Please try again.");
      setSnackBarSeverity("error");
    } finally {
      setOpen(false); // Close dialog after deletion
      setSnackBarOpen(true); // Open the snackbar
    }
  };

  const handleCloseSnackbar = () => {
    setSnackBarOpen(false);
  };


  return (
    <Paper
      sx={{
        width: "100%",
        overflow: "hidden",
        marginTop: "30px",
      }}
    >
      <nav>
        <ol className="breadcrumb d-none d-lg-flex ms-3">
          <li className="breadcrumb-item">
            <i className="bi bi-house lh-1"></i>
            <Link
              to="/dashboard"
              className="text-decoration-none"
              style={{ color: "#41505f" }}
            >
              Home
            </Link>
          </li>
          <li className="breadcrumb-item">
            <Link
              to="/trips"
              className="text-decoration-none"
              style={{ color: "#41505f" }}
            >
              Trips
            </Link>
          </li>
          <li className="breadcrumb-item opacity-50">TripDetails</li>
        </ol>
      </nav>
      {tripDetails ? (
        <Grid item xs={12} md={8}>
          <Card style={{ marginTop: "10px" }} elevation={2}>
            <CardContent>
              <Stack direction="row" spacing={2} justifyContent="space-between">
                <div>
                  <Typography variant="overline" color="#667085">
                    Trip Id:
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Typography fontSize="1rem">{id}</Typography>
                  </div>
                </div>
                <Divider orientation="vertical" flexItem />
                <div>
                  <Typography variant="overline" color="#667085">
                    Driver
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <Typography color="black" fontSize="1rem">
                      {tripDetails[0]?.riderDetails?.[0]?.first_name || "N/A"}{" "}
                      {tripDetails[0]?.riderDetails?.[0]?.last_name || "N/A"}
                    </Typography>
                    <Typography variant="overline" color="#667085">
                      {tripDetails[0]?.riderDetails?.[0]?.phone_number || "N/A"}
                    </Typography>
                  </div>
                </div>
                <Divider orientation="vertical" flexItem />
                <div>
                  <Typography variant="overline" color="#667085">
                    Passenger:
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Typography color="black" fontSize="1rem">
                      {tripDetails[0]?.userDetails?.[0]?.first_name || "N/A"}{" "}
                      {tripDetails[0]?.userDetails?.[0]?.last_name || "N/A"}
                    </Typography>
                    <Typography variant="overline" color="#667085">
                      {tripDetails[0]?.userDetails?.[0]?.phone_number || "N/A"}
                    </Typography>
                  </div>
                </div>
                <Divider orientation="vertical" flexItem />
                <div>
                  <Typography variant="overline" color="#667085">
                    Amount
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Typography variant="overline">
                      {tripDetails[0]?.bidDetails[0]?.amount}
                    </Typography>
                  </div>
                </div>
                <Divider orientation="vertical" flexItem />
                <div>
                  <Typography variant="overline" color="#667085">
                    Route:
                  </Typography>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {/* Icons and line column */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginRight: "10px",
                      }}
                    >
                      <SvgIcon style={{ color: "red", fontSize: "small" }}>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </SvgIcon>
                      <div
                        style={{
                          width: "2px",
                          height: "30px",
                          backgroundColor: "#ccc",
                          margin: "5px 0",
                        }}
                      />
                      <SvgIcon style={{ color: "green", fontSize: "small" }}>
                        <FiberManualRecordIcon style={{ fontSize: "small" }} />
                      </SvgIcon>
                    </div>
                    {/* Text column */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "25px",
                      }}
                    >
                      <Typography fontSize="14px">
                        {
                          tripDetails[0]?.cabRequestDetails[0]?.pickup_location?.subtext
                           
                        }
                      </Typography>
                      <Typography fontSize="14px">
                        {
                          tripDetails[0]?.cabRequestDetails[0]?.drop_location?.subtext
                            
                        }
                      </Typography>
                    </div>
                  </div>
                </div>
                <Divider orientation="vertical" flexItem />
                <div>
                  <Typography variant="overline" color="#667085">
                    Vehicle Number
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Typography variant="overline">
                      {tripDetails[0]?.riderDetails[0]?.vehicle_number}
                    </Typography>
                  </div>
                </div>
              </Stack>
            </CardContent>
          </Card>
          {/* New section for trip details */}
          <Card style={{ marginTop: "10px" }} elevation={2}>
            <CardContent>
              <Stack direction="row" spacing={2} justifyContent="space-between">
                <div>
                  <Typography variant="overline" color="#667085">
                    Distance:
                  </Typography>
                  <Typography>{tripDetails[0]?.distance}</Typography>
                </div>
                <Divider orientation="vertical" flexItem />
                <div>
                  <Typography variant="overline" color="#667085">
                    Trip Start Time:
                  </Typography>
                  <Typography>
                    {formattedDate(tripDetails[0]?.tripDate)},{" "}
                    {formattedTime(tripDetails[0]?.tripTime)}
                  </Typography>
                </div>

                <Divider orientation="vertical" flexItem />
                <div>
                  <Typography variant="overline" color="#667085">
                    Trip End Time:
                  </Typography>
                  <Typography>
                    {formattedDate(tripDetails[0]?.trip_end_time)}
                  </Typography>
                </div>
                <Divider orientation="vertical" flexItem />
                <div>
                  <Typography variant="overline" color="#667085">
                    Status:
                  </Typography>
                  <Typography>{tripDetails[0]?.status}</Typography>
                </div>
                <Divider orientation="vertical" flexItem />
                <div>
                  <Typography variant="overline" color="#667085">
                    Payment Mode:
                  </Typography>
                  <Typography>{tripDetails[0]?.payment}</Typography>
                </div>
                <Divider orientation="vertical" flexItem />
                <div>
                  <Typography variant="overline" color="#667085">
                    Payment status:
                  </Typography>
                  <Typography>{tripDetails[0]?.payment}</Typography>
                </div>
                <Divider orientation="vertical" flexItem />
                <div>
                  <Typography variant="overline" color="#667085">
                    Cancelled By:
                  </Typography>
                  <Typography>{tripDetails[0]?.cancelledBy}</Typography>
                </div>
              </Stack>
            </CardContent>
          </Card>

          {tripDetails && (
            <Card style={{ marginTop: "10px" }} elevation={2}>
              <CardContent>
                <Typography variant="h6" color="#667085" gutterBottom>
                  Pricing Details
                </Typography>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="space-between"
                >
                  {/* Trip Title */}
                  <div>
                    <Typography variant="overline" color="#667085">
                      Trip Title:
                    </Typography>
                    <Typography>
                      {tripDetails[0]?.tripTitle || "N/A"}
                    </Typography>
                  </div>
                  <Divider orientation="vertical" flexItem />
                  {/* No of Persons */}
                  <div>
                    <Typography variant="overline" color="#667085">
                      No of Persons:
                    </Typography>
                    <Typography>
                      {tripDetails[0]?.numberOfPersons ?? "N/A"}
                    </Typography>
                  </div>
                  <Divider orientation="vertical" flexItem />
                  {/* Start OTP */}
                  <div>
                    <Typography variant="overline" color="#667085">
                      Start OTP:
                    </Typography>
                    <Typography>{tripDetails[0]?.startOtp || "N/A"}</Typography>
                  </div>
                  <Divider orientation="vertical" flexItem />
                  {/* End OTP */}
                  <div>
                    <Typography variant="overline" color="#667085">
                      End OTP:
                    </Typography>
                    <Typography>{tripDetails[0]?.endOtp || "N/A"}</Typography>
                  </div>
                </Stack>
                <Divider style={{ margin: "20px 0" }} />
                {/* Detailed Pricing Breakdown */}
                <Typography variant="h6" color="#667085" gutterBottom>
                  Detailed Pricing Breakdown
                </Typography>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="space-between"
                >
                  {/* Base Amount */}
                  <div>
                    <Typography variant="overline" color="#667085">
                      Base Amount:
                    </Typography>
                    <Typography>
                      ₹{tripDetails[0]?.pricing?.baseAmount?.value || 0}
                    </Typography>
                  </div>
                  {/* Discount */}
                  <div>
                    <Typography variant="overline" color="#667085">
                      Discount:
                    </Typography>
                    <Typography>
                      {tripDetails[0]?.pricing?.discount?.config?.type ||
                        "None"}{" "}
                      - ₹{tripDetails[0]?.pricing?.discount?.value || 0}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      Reason:{" "}
                      {tripDetails[0]?.pricing?.discount?.config?.reason ||
                        "N/A"}
                    </Typography>
                  </div>
                  {/* Tax */}
                  <div>
                    <Typography variant="overline" color="#667085">
                      Tax:
                    </Typography>
                    <Typography>
                      CGST: {tripDetails[0]?.pricing?.tax?.cgst?.value || 0}%,
                      SGST: {tripDetails[0]?.pricing?.tax?.sgst?.value || 0}%
                    </Typography>
                    <Typography>
                      Total Tax: ₹
                      {tripDetails[0]?.pricing?.tax?.total?.value || 0}
                    </Typography>
                  </div>
                  {/* Convenience Fee */}
                  <div>
                    <Typography variant="overline" color="#667085">
                      Convenience Fee:
                    </Typography>
                    <Typography>
                      ₹
                      {tripDetails[0]?.pricing?.platformFee?.netFee?.value || 0}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {tripDetails[0]?.pricing?.platformFee?.discount?.key ||
                        ""}
                    </Typography>
                  </div>
                  {/* Final Amount */}
                  <div>
                    <Typography variant="overline" color="#667085">
                      Final Amount:
                    </Typography>
                    <Typography>
                      ₹
                      {tripDetails[0]?.pricing?.finalAmount?.toFixed(2) ||
                        "N/A"}
                    </Typography>
                  </div>
                </Stack>
              </CardContent>
            </Card>
          )}

          <Grid item xs={12} md={8} style={{ marginTop: "5px" }}>
            <RouteView tripDetails={tripDetails[0]} />
          </Grid>
          <Button
            variant="contained"
            color="error" // Red button for danger actions
            style={{ marginTop: "10px" }}
            onClick={() => handleOpenDialog(tripDetails[0]._id)} 
          >
            Delete Trip
          </Button>

          <Dialog
        open={open}
        onClose={handleCloseDialog}
        aria-labelledby="delete-trip-dialog-title"
        aria-describedby="delete-trip-dialog-description"
      >
        <DialogTitle id="delete-trip-dialog-title">Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-trip-dialog-description">
            Are you sure you want to delete this trip? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteTrip} color="error" variant="contained" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

       {/* Snackbar for feedback */}
       <Snackbar
        open={snackBarOpen}
        autoHideDuration={6000} // Snackbar will automatically hide after 6 seconds
        onClose={handleCloseSnackbar}
        message={snackBarMessage}
        severity={snackBarSeverity} // can be 'success' or 'error'
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      />
        </Grid>
      ) : (
        <div>
          <Typography>No Trip Found for the ID</Typography>
        </div>
      )}
      {/* </div> */}
    </Paper>
  );
}

export default TripDetails;
